module.exports = __webpack_public_path__ + "images/liinilaevad/routes/GDN-NYN-GDN-inactive@3x.png";